export const CommonPage = {
    data() {
        return {
            stateData: [
                {
                    name: "禁用",
                    value: 0
                },
                {
                    name: "启用",
                    value: 1
                }
                // {
                //     name: "删除",
                //     value: -1
                // },
                // {
                //     name: "临时导入没有正式入库",
                //     value: -2
                // }
            ],
            queTypeData: [
                { name: "单选题", value: 1 },
                { name: "多选题", value: 2 },
                { name: "填空题", value: 3 },
                { name: "判断题", value: 4 },
                { name: "问答题", value: 5 }
            ],
            difficultyData: [
                {
                    name: "简单",
                    value: 1
                },
                {
                    name: "普通",
                    value: 2
                },
                {
                    name: "困难",
                    value: 3
                }
            ],
            // 用途
            useForData: [
                {
                    name: "考试",
                    value: 1
                },
                {
                    name: "作业",
                    value: 2
                },
                {
                    name: "前台练习",
                    value: 3
                }
            ]
        };
    },
    methods: {
        flagPromise(arrPro, loadingKey) {
            if (loadingKey) {
                this.flag[loadingKey] = true;
            } else {
                this.flag.loading = true;
            }

            return Promise.all(arrPro)
                .then((res) => {
                    return res;
                })
                .finally(() => {
                    if (loadingKey) {
                        this.flag[loadingKey] = false;
                    } else {
                        this.flag.loading = false;
                    }
                });
        },
        /**
         * @param page 当前页
         * @param pageSize 每页大小
         * @param total 所有数据总量
         * @param delCount 删除了多少条数据
         * @return {boolean} 是否需要回到上一页
         */
        needToPrePage({ page, pageSize, total, delCount }) {
            if (page === 1) return false;
            let pages = Math.ceil(total / pageSize)
            // 最后一页
            if (page === pages) {
                let currentLength = total % pageSize
                return delCount >= currentLength
            } else {
                return false
            }
        },
    }
};
